import React, { useEffect } from 'react'
import QuizHeader from './QuizHeader'
import QuestionList from './QuestionList'
import NextButton from './NextButton'
import SubmissionHeader from './SubmissionHeader'
import Submission from './Submission'
import QuizModal from './QuizModal'
import { CardHeader, Col, ModalBody, Row } from 'reactstrap'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { setQuizTimer } from 'store/Quiz/actions'
import { closeQuizOverlay } from 'store/Quiz/actions'

const QuizOverlay = (props) => {
	const language = props.language || {}
	const name = useSelector((state) => state.courses.name)
	const history = useHistory()
	const dispatch = useDispatch()

	useEffect(() => {
		if (props.quizTimer && props.quizCount === 0) {
			dispatch(setQuizTimer(parseInt(props.quizTimer * 60)))
		}
	}, [])

	useEffect(() => {
		if (props.submitted) {
			// props.dispatch(props.fetchSubmission(props.course_id))
			history.replace({
				pathname: `/course/${props.course_id}/submission`,
			})
		}
	}, [props])

	return (
		<QuizModal
			courseId={props.course_id}
			size={props.isSubmission ? 'mad' : 'lg'}
			className={props.isSubmission ? 'mad' : 'quiz_modal'}
			language={props.language}
			onSubmit={props.onSubmit}
			dispatch={props.dispatch}
			isSubmission={props.isSubmission}
		>
			<div>
				<div>
					{props.isSubmission ? (
						<div className='submission_modal-body'>
							<div className=''>
								<SubmissionHeader {...props} />
							</div>
							<ModalBody className=''>
								<div className='container-fluid'>
									<Submission {...props} />
								</div>
							</ModalBody>
						</div>
					) : null}

					{!props.isSubmission ? (
						<>
							<CardHeader className='py-3'>
								<Row className='align-items-center'>
									<Col xs='8'>
										<h3 className='mb-0'>{props.isSubmission ? '' : name}</h3>
									</Col>
									<Col className='text-right' xs='4'>
										<button
											className='btn btn-info py-2 px-4'
											onClick={() => props.dispatch(props.onSubmit())}
										>
											{language.general ? language.general.submit : null}
										</button>
									</Col>
								</Row>
							</CardHeader>
							<ModalBody className='quiz_modal-body py-1'>
								<div className='container-fluid'>
									<QuizHeader {...props} />
									{!props.countEnded ? (
										<React.Fragment>
											<QuestionList {...props} />
											<NextButton {...props} />
										</React.Fragment>
									) : (
										<div>
											<p style={{ marginTop: '15px' }}>
												Your time has been over please submit your answers so
												you wont loose them. You will no longer have access to
												this quiz. Good luck!
											</p>
										</div>
									)}
								</div>
							</ModalBody>
						</>
					) : null}
				</div>
			</div>
		</QuizModal>
	)
}

export default QuizOverlay
